import React, { memo, useEffect } from "react";
import { validators } from "investira.sdk";
import { Stack, Divider } from "investira.react.components";
import ConsultaProvider from "../../../../contexts/ConsultaContext";
import useKickBack from "../../../../hooks/useKickBack";
import withMessage from "../../../../hoc/withMessage";
import PlanoPosicao from "../PlanoPosicao";
import Secoes from "./Secoes";
import Highlights from "./Highlights";

const ConsultaStressTest = memo((props) => {
  const { data } = props;
  const kick = useKickBack();

  const ativosFiltered = (
    ativos = [],
    filtrarComErro = false,
    atributoErro = "erros"
  ) => {
    if (!Array.isArray(ativos)) return [];

    return ativos.filter((ativo) =>
      filtrarComErro
        ? ativo.hasOwnProperty(atributoErro)
        : !ativo.hasOwnProperty(atributoErro)
    );
  };

  useEffect(() => {
    kick && props.onMessage("Entidade alterada");
  }, [kick]);

  if (validators.isEmpty(data)) {
    return null;
  }

  const xAtivos = ativosFiltered(data.response.detalhe, false);
  const xAtivosError = ativosFiltered(data.response.detalhe, true);
  const xAtivosErrorSize = xAtivosError.length;
  const hasError = xAtivosErrorSize > 0;

  return (
    <ConsultaProvider>
      <Stack spacing={2}>
        <PlanoPosicao
          beta={false}
          created={data.request?.data}
          carteira={data.request_metadata?.carteira}
        />
        <Divider />
        <Stack sx={{ gap: 2 }} component="section">
          <Highlights data={data} />
          <Stack>
            <Secoes data={data} />
          </Stack>
        </Stack>
      </Stack>
    </ConsultaProvider>
  );
});

export default withMessage(ConsultaStressTest);
